import React from 'react'
import './footer.css'

const Footer = () => {
  return (

    <footer className='footer'>
        <div className='footer__container container'>
            <h1 className='footer__title'>Salar Mokhtari Laleh</h1>
            <span className='footer__copy'>&#169; Salar-Mokhtari-Laleh-Open-Source-License</span>
        </div>
    </footer>
  )
}

export default Footer